// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import { hot } from 'react-hot-loader'
import './styles.scss'

import SupercarCards from '../supercarCards'
import Scrollchor from 'react-scrollchor'
import Masthead from '@ta-interaktiv/react-masthead'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import { Footer } from '@ta-interaktiv/react-footer'
import TextExpander from '../ToggleText'

import { Waypoint } from 'react-waypoint'

type Props = {
  articleId: string
}

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '31192245'
  }

  constructor(props) {
    super(props)
    this.trackTopClicks = this.trackTopClicks.bind(this)
  }

  trackTopClicks(target) {
    let clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Back: ' + clickedText
    })
  }

  trackDownClicks(target) {
    let clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'Forward: ' + clickedText
    })
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={this.props.articleId} />

        <header className='ui vertical fitted segment' id='start'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Avez-vous vu ces 50 voitures de superluxe?
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                La justice suisse est à la poursuite d’une collection de bolides
                à plaques genevoises, valant au moins 45 millions de francs.
                Elle en a fait saisir une partie à Genève et en Allemagne. Nous
                avons dressé la liste complète de ces véhicules de folie.
                Puissance totale: 41&nbsp;000 chevaux!
              </div>
            </h2>
            <p className='ta author'>
              <strong>Sylvain Besson, Oliver Zihlmann, Patrick Vögeli</strong>
            </p>
          </div>
          <div>
            <img
              src={require('./img/supercars.svg')}
              alt=''
              class='ui fluid image headerImage mobile hidden'
            />
            <img
              src={require('./img/supercars-mobile.svg')}
              alt=''
              class='ui fluid image headerImage mobile only'
            />
          </div>
        </header>

        <div className='ui text container intro' id='recherche'>
          <TextExpander
            // title=""
            trackingID='Mehr Lesen'
          />
        </div>

        <main className='ui vertical fitted segment'>
          <div className='ui text container'>
            <h2>La collection de tous les superlatifs</h2>
          </div>

          <div
            className='ui text container cars first'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='bugattis'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>1. Les Bugatti</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#start'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backStart')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Il n’existe que trois exemplaires de la Bugatti Veyron Black Bess,
              incrustée de fils d’or. Les modèles de la série limitée «World
              record edition» dont elle fait partie sont d’une puissance
              monstrueuse - 1200 CV - et peuvent dépasser 400 km/h. A elles
              seules, les Bugatti de Khadem al-Qubaisi valent au moins 12,5
              millions de francs et pourraient se vendre beaucoup plus aux
              enchères.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='bugattis' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='hypercars'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>2. Les «hypercars»</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#bugattis'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backHypercars')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#ferraris'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardHypercars')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              On appelle ainsi les bolides de marques exotiques comme Pagani ou
              Koenigsegg: rares, chers et quasiment faits sur mesure pour des
              clients fortunés. Les Pagani ont une allure extraterrestre qui
              leur a permis de figurer dans le film «Transformers».
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='hypercars' />
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '20ContentRead'
                })
              }
            }}
          />

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='ferraris'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>3. Les Ferrari</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#hypercars'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backFerraris')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#lamborghinis'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardFerraris')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Plus communes, les puissantes italiennes comprennent aussi des
              modèles d’exception comme la Enzo (conduite par Demi Moore dans le
              film «Drôles de Dames») et surtout «LaFerrari» dont un exemplaire
              s’est vendu 10 millions de francs en 2017. Khadem al-Qubaisi en
              possédait deux.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='ferraris' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='lamborghinis'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>4. Les Lamborghini</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#ferraris'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backLamborghinis')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#porsches'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardLamborghinis')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              En 2010, Khadem al-Qubaisi a été photographié par un «spotter» -
              un fanatique de voitures - à St Tropez dans sa Lamborghini
              Murcielago Reventón dont il n’existe que 22 exemplaires. Il a
              aussi été pris dans sa Bugatti Veyron Grand Sport et dans une très
              coûteuse Mercedes SLR Stirling Moss qui n’apparaît même pas sur la
              liste des véhicules séquestrés à Genève.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='lamborghinis' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='porsches'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>5. Les Porsche</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#lamborghinis'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backPorsches')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#astonmartins'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardPorsches')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              La Porsche 918 Spyder appartient à la catégorie des supercars
              grâce à sa propulsion hybride qui la rend extrêmement rapide - et
              chère. Plusieurs modèles coûtent plus d'un million de francs.
              Al-Qubaisi en avait quatre, en rouge, jaune, bleu ou gris. Sa
              Carrera GT, améliorée par le tuner allemand Gemballa, est la seule
              voiture de très grande valeur que le tribunal civil de Genève a pu
              confisquer.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='porsches' />
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '50ContentRead'
                })
              }
            }}
          />

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='astonmartins'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>6. Les Aston Martin</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#porsches'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backAstonmartins')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#mclarens'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardAstonmartins')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              La voiture de James Bond ne pouvait pas manquer à cette
              collection. Daniel Craig conduisait une Aston Martin DBS dans le
              film «Casino Royale». Al-Qubaisi avait aussi un modèle bien plus
              cher, l’Aston Martin One-77. Comme son nom l'indique, elle n’a été
              produite qu’à 77 exemplaires.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards centered doubling stackable'>
              <SupercarCards Kategorie='astonmartins' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='mclarens'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>7. Les McLaren</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#astonmartins'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backMclarens')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#mercedes'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardMclarens')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Le modèle bleu McLaren P1 de Mc Laren à un million de francs est
              toujours porté disparu. Mais l'une des deux McLaren MP4 12 C,
              nettement moins chères, a été confisquée à Genève. Cette voiture
              «bon marché» ne semble pas avoir tellement plu à son propriétaire.
              Quand on l'a trouvée, elle avait 0 km au compteur.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards centered doubling stackable'>
              <SupercarCards Kategorie='mclarens' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='mercedes'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>8. Les Mercedes</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#mclarens'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backMercedes')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#luxus-limousinen'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardMercedes')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Cette partie de la collection comprend deux exemplaires
              spécialement «tunés» par le spécialiste des moteurs Brabus. Le
              modèle EV12 avait été baptisé «la plus vicieuse des Benz» par le
              Spiegel. On l’appelle aussi la «Batmobile» des autoroutes
              allemandes.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='mercedes' />
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '75ContentRead'
                })
              }
            }}
          />

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='luxus-limousinen'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>9. Les limousines de luxe</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#mercedes'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backLuxuslimousinen')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#offroader'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() =>
                      this.trackDownClicks('forwardLuxuslimousinen')
                    }
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Pour un peu plus de dignité, vous auriez pu choisir l'une des sept
              Rolls-Royce ou la Bentley de la collection. Avec des couleurs pour
              toutes les occasions. Et même, pour les jours de beau temps, une
              Rolls-Royce décapotable rare et chère de la gamme Phantom.
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='luxus-limousinen' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='offroader'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>10. Les tout-terrain</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#luxus-limousinen'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backOffroader')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>

                <Scrollchor
                  to='#normalen'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='down-link'
                    onClick={() => this.trackDownClicks('forwardOffroader')}
                  >
                    <i className='chevron down icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Al-Qubaisi disposait d'un véritable parc de Mercedes tout-terrain,
              dont plusieurs modèles presque identiques de la Classe G, sans
              doute destinés à être offerts à des personnalités émiraties. Tous
              sont équipés de moteurs haute performance AMG. Chez AMG, chaque
              moteur est assemblé par un seul technicien. Le principe est : «Un
              homme, un moteur».
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='offroader' />
            </div>
          </div>

          <div
            className='ui text container cars'
            style={{ marginBottom: '3em' }}
          >
            <div className='innerWrapper' id='normalen'>
              <h2 className='questionTitleWrapper'>
                <span className='titleText'>11. Les «normales»</span>
              </h2>

              <div className='topDownNav'>
                <Scrollchor
                  to='#offroader'
                  className='upScrollchor white'
                  animate={{ offset: -15 }}
                >
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('backNormalen')}
                  >
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>

            <p className='introKategorie'>
              Al-Qubaisi avait aussi quelques voitures qu’on peut qualifier de
              «normales». La BMW X6 a été confisquée à Genève. Elle avait 30'000
              kilomètres au compteur. C'est donc le seul des véhicules
              séquestrés à avoir été vraiment conduit. Un mystère subsiste
              enfin: qu’est-ce qu'une mini voiture comme la Cygnet vient faire
              dans cette collection?
            </p>
          </div>
          <div className='ui container'>
            <div className='ui four cards doubling stackable'>
              <SupercarCards Kategorie='normalen' />
            </div>
          </div>
        </main>
        <div>
          <Footer
            locale='fr'
            hidePortfolioTeaser
            articleId={this.props.articleId}
            starColor='yellow'
            questions={['Ce contenu était-il informatif?']}
            credits={[
              ['Texte', 'Sylvain Besson et Oliver Zihlmann'],
              ['Concept et programmation', 'Patrick Vögeli, Team interactive'],
              ['Données', 'Office fédéral des routes OFROU']
            ]}
          >
            <div className='ui vertical fitted attached segment' id='methodik'>
              <div
                className='ui text container methodik'
                style={{ position: 'relative' }}
              >
                <div className='innerWrapperMethodik'>
                  <h3 className='methodik'>Méthodologie</h3>
                </div>

                <p>
                  Nous avons retrouvé des photos de certains véhicules d’origine
                  et utilisé sinon des images de modèles identiques. Avec l’aide
                  de l’Office fédéral des routes, nous avons pu retrouver le
                  numéro de châssis des véhicules, leur couleur, la puissance du
                  moteur et l’année de leur mise en circulation (
                  <a href='https://interactif.24heures.ch/2019/voitures-superluxe/extrait.jpg'>
                    <i className='file alternate outline icon' />
                    Extrait
                  </a>
                  ).
                </p>
                <p>
                  Certains véhicules ont été importés et exportés en Suisse à
                  plusieurs reprises et possèdent de ce fait plusieurs numéros
                  de plaques. Les prix viennent d’estimations d’experts.
                  Certains modèles peuvent atteindre des montants beaucoup plus
                  élevés aux enchères.
                </p>
              </div>
            </div>
          </Footer>
        </div>
      </div>
    )
  }
}

export default hot(module)(AppComponent)
